The scheme ID of the pay types.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
